var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { InputBase } from '../InputBase';
import classNames from 'classnames';
import styles from '../Base.module.css';
export default React.forwardRef(function Select(props, ref) {
    var options = props.options, placeholder = props.placeholder, defaultOptionAvailable = props.defaultOptionAvailable, baseProps = __rest(props, ["options", "placeholder", "defaultOptionAvailable"]);
    var requiredForPlaceHolder = !baseProps.label && baseProps.required;
    var placeholderString = placeholder
        ? "".concat(placeholder, " ").concat(requiredForPlaceHolder ? '*' : '')
        : undefined;
    return (React.createElement(InputBase, __assign({}, baseProps, { forwardedRef: ref, inputComponent: function (restProps) {
            var e_1, _a;
            if (!restProps.value)
                restProps.className = classNames(restProps.className, styles.placeholder);
            var getOptionElement = function (option) { return (React.createElement("option", { value: option.id, key: option.id }, option.name)); };
            // eslint-disable-next-line prefer-const
            var optionElements = [];
            try {
                // eslint-disable-next-line react/prop-types
                for (var _b = __values(options.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), index = _d[0], option = _d[1];
                    if ('label' in option) {
                        optionElements.push(React.createElement("optgroup", { key: index, label: option.label }, option.options.map(getOptionElement)));
                    }
                    else {
                        optionElements.push(getOptionElement(option));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return (React.createElement("select", __assign({}, restProps),
                React.createElement("option", { value: '', disabled: !defaultOptionAvailable }, placeholderString !== null && placeholderString !== void 0 ? placeholderString : '-- Выберите вариант --'),
                optionElements));
        } })));
});
